
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pageUrl]",
      function () {
        return require("private-next-pages/[pageUrl].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pageUrl]"])
      });
    }
  